import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { MRT_ColumnFilterFnsState } from 'material-react-table';
export interface AuditoriaTableState {
  page: number;
  pageSize: number;
  columnFilters: MRT_ColumnFilterFnsState;
  setState: (state: Partial<AuditoriaTableState>) => void;
  hasSnapshot: boolean;
  clear: () => void;
}
const initalState = {
  page: 0,
  pageSize: 10,
  columnFilters: {},
  hasSnapshot: false,
}
export const useAuditoriaTableStore = create<AuditoriaTableState>()(
  persist(
    (set) => ({
      ...initalState,
      setState: (state) => set({
        ...state,
        hasSnapshot: true
      }),
      clear: () => set(initalState)
    }),
    {
      name: 'auditoria-table-state',
    }
  )
);